import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import "./reset.scss";
import classNames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { handlePostRequest } from "../services/PostTemplate";
import { ToastContainer, toast } from "react-toastify";

function Reset() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");
    const dispatch = useDispatch();

    let history = useHistory();

    const validationSchema = Yup.object().shape({
        email: Yup.string().required("This field is required."),
    });
    
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            email: "",
        },
        onSubmit: async (data) => {
            const res = await dispatch(handlePostRequest(data, "/resethash", true, true));
            const userData = res?.data;
            toast.success("Email sent, Please check your email to reset your password.");
        },
    });
    
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <ToastContainer />
            <div className="reset_body">
                <div className="reset_container">
                    <div className="logo_section">
                        <img 
                            src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg" 
                            alt="Move4wd Logo"
                            className="reset_logo"
                        />
                    </div>
                    
                    <div className="reset_content">
                        <h1 className="reset_header">Reset Your Password</h1>
                        <p className="reset_sub_header">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>
                        
                        <form className="reset_form" onSubmit={formik.handleSubmit}>
                            <div className="input_wrapper">
                                <input 
                                    id="email" 
                                    className={classNames({ "p-invalid": isFormFieldValid("email") }, "reset_input")} 
                                    name="email" 
                                    value={formik.values.email} 
                                    placeholder="Enter your email address" 
                                    onChange={formik.handleChange} 
                                    type="email" 
                                />
                                {getFormErrorMessage("email")}
                            </div>

                            <div className="button_wrapper">
                                <Button 
                                    className="reset_button" 
                                    label="Send Reset Link" 
                                    icon={loadingIcon || ""} 
                                    iconPos="right" 
                                    disabled={loading} 
                                />
                            </div>

                            <div className="back_to_login">
                                <p>
                                    Remember your password? 
                                    <button 
                                        type="button" 
                                        className="back_link"
                                        onClick={() => history.push('/login')}
                                    >
                                        Back to Sign In
                                    </button>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Reset;